import { gql } from '@apollo/client';
/**
 * @const CreateEntityFromAssetMutation
 * @since 1.0.0
 */
export const CreateEntityFromAssetMutation = gql `
  mutation CreateEntityFromAssetMutation($input: CreateEntityFromAssetInput!) {
    createEntityFromAsset(input: $input)
  }
`;
